export interface LogoProps {
  color?: ColorOptions;
  className?: string;
}

export function Logo({ color = 'navy', className = '' }: LogoProps) {
  const styles = styleMap[color];
  return (
    <svg
      fill="none"
      viewBox="0 0 246 54"
      className={`inline-block ${className}`}
    >
      <g clipPath="url(#a)" className={styles.wordmarkColor}>
        <path d="m87.293 42.721-6.204-11.176h-1.742v11.176h-7.265V13.115h12.194c2.35 0 4.348.408 5.99 1.223 1.672.815 2.918 1.94 3.74 3.374.82 1.406 1.231 2.98 1.231 4.724 0 1.968-.566 3.725-1.699 5.271-1.105 1.547-2.747 2.643-4.928 3.29l6.883 11.724h-8.2Zm-7.946-16.279h4.504c1.331 0 2.323-.323 2.974-.97.68-.647 1.02-1.56 1.02-2.741 0-1.125-.34-2.01-1.02-2.657-.651-.647-1.643-.97-2.974-.97h-4.504v7.338ZM123.421 30.575c0 .675-.043 1.378-.128 2.109h-16.442c.113 1.462.581 2.587 1.402 3.374.85.759 1.884 1.139 3.102 1.139 1.812 0 3.073-.76 3.781-2.278h7.733a10.375 10.375 0 0 1-2.167 4.175c-1.02 1.237-2.309 2.207-3.867 2.91-1.557.703-3.299 1.055-5.225 1.055-2.323 0-4.391-.492-6.204-1.476-1.812-.984-3.229-2.39-4.248-4.218-1.02-1.827-1.53-3.964-1.53-6.41s.496-4.583 1.487-6.41c1.02-1.828 2.436-3.234 4.249-4.218 1.813-.984 3.895-1.476 6.246-1.476 2.294 0 4.333.478 6.118 1.434a10.197 10.197 0 0 1 4.163 4.09c1.02 1.772 1.53 3.838 1.53 6.2Zm-7.435-1.898c0-1.237-.425-2.22-1.275-2.952-.85-.73-1.912-1.097-3.186-1.097-1.218 0-2.252.352-3.102 1.055-.821.703-1.331 1.7-1.529 2.994h9.092ZM127.084 30.997c0-2.334.481-4.414 1.444-6.242.992-1.828 2.309-3.247 3.951-4.26a10.102 10.102 0 0 1 5.439-1.56c1.501 0 2.846.267 4.036.801 1.19.506 2.153 1.223 2.889 2.151v-2.699h7.265V53.94h-7.265V39.77a9.213 9.213 0 0 1-3.016 2.36c-1.162.591-2.493.886-3.994.886a10.02 10.02 0 0 1-5.354-1.518c-1.642-1.012-2.959-2.432-3.951-4.26-.963-1.827-1.444-3.907-1.444-6.241Zm17.759-.042c0-1.265-.255-2.32-.765-3.163-.481-.872-1.118-1.519-1.912-1.94a5.003 5.003 0 0 0-2.506-.675c-.85 0-1.671.225-2.464.675-.794.421-1.445 1.068-1.955 1.94-.51.871-.765 1.94-.765 3.205 0 1.265.255 2.334.765 3.205.51.844 1.161 1.49 1.955 1.94a5.181 5.181 0 0 0 2.464.633c.849 0 1.671-.211 2.464-.633.821-.45 1.473-1.11 1.954-1.982.51-.872.765-1.94.765-3.205ZM182.049 19.188v23.533h-7.265v-3.205c-.736 1.04-1.742 1.884-3.017 2.53-1.246.62-2.634.928-4.163.928-1.813 0-3.413-.393-4.801-1.18-1.388-.816-2.465-1.983-3.229-3.501-.765-1.518-1.147-3.304-1.147-5.356V19.188h7.222v12.779c0 1.574.411 2.797 1.232 3.669.822.872 1.927 1.307 3.314 1.307 1.417 0 2.535-.435 3.357-1.307.821-.872 1.232-2.095 1.232-3.67V19.189h7.265ZM192.196 16.742c-1.274 0-2.322-.366-3.144-1.097-.793-.759-1.189-1.687-1.189-2.783 0-1.125.396-2.053 1.189-2.784.822-.759 1.87-1.138 3.144-1.138 1.247 0 2.266.38 3.059 1.138.822.731 1.232 1.66 1.232 2.784 0 1.096-.41 2.024-1.232 2.783-.793.731-1.812 1.097-3.059 1.097Zm3.612 2.446v23.533h-7.266V19.188h7.266ZM215.561 36.606v6.115h-3.697c-2.634 0-4.687-.632-6.16-1.897-1.473-1.294-2.21-3.389-2.21-6.285v-9.362h-2.889v-5.989h2.889v-5.736h7.266v5.736h4.758v5.989h-4.758v9.447c0 .703.17 1.209.509 1.518.34.31.907.464 1.7.464h2.592ZM245.099 19.188l-14.87 34.71h-7.817l5.438-11.978-9.645-22.732h8.115l5.481 14.719 5.438-14.719h7.86Z" />
      </g>
      <path
        d="M11.02 17.332c0-.9.393-1.757 1.077-2.343l15.24-13.074a3.088 3.088 0 0 1 4.021 0l15.24 13.074a3.088 3.088 0 0 1 1.077 2.343v19.95a3.088 3.088 0 0 1-3.088 3.088H14.108a3.088 3.088 0 0 1-3.088-3.088v-19.95Z"
        fill="#677FD0"
        className={styles.iconBackgroundFill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.33 23.651a3.088 3.088 0 0 0-1.077 2.344v19.95a3.088 3.088 0 0 0 3.088 3.088h30.48a3.088 3.088 0 0 0 3.086-2.968l7.617-6.53h-7.615v-13.54c0-.901-.394-1.757-1.078-2.344l-15.24-13.073a3.088 3.088 0 0 0-4.02 0L3.33 23.65Z"
        fill="#D0D7F3"
        className={styles.iconForegroundFill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.116 2.804a1.917 1.917 0 0 0-2.497 0l-6.976 5.984c.401.168.783.4 1.129.697l15.24 13.074a4.26 4.26 0 0 1 1.485 3.232V39.2h5.61a1.917 1.917 0 0 0 1.917-1.918v-19.95c0-.559-.244-1.09-.669-1.455L31.115 2.804Zm6.04 36.395V25.791c0-.56-.245-1.09-.67-1.455L21.248 11.263a1.917 1.917 0 0 0-2.383-.09l-5.485 4.704a1.917 1.917 0 0 0-.669 1.455v19.95c0 1.06.859 1.918 1.918 1.918h22.528ZM10.369 18.454v18.83a4.259 4.259 0 0 0 4.259 4.258h22.528v4.2a1.917 1.917 0 0 1-1.918 1.917H4.76a1.917 1.917 0 0 1-1.917-1.917v-19.95c0-.56.244-1.09.669-1.455l6.858-5.883Zm7.024-9.104 9.701-8.323a4.26 4.26 0 0 1 5.546 0L47.88 14.1a4.26 4.26 0 0 1 1.486 3.232v19.95a4.254 4.254 0 0 1-1.835 3.503l-9.467 8.143A4.243 4.243 0 0 1 35.238 50H4.76A4.259 4.259 0 0 1 .5 45.741v-19.95a4.26 4.26 0 0 1 1.486-3.232l15.24-13.074c.055-.047.11-.092.167-.136Zm22.104 35.257v-3.065h3.563l-3.563 3.065Z"
        fill="#2A3663"
        className={styles.iconStroke}
      />
      <defs>
        <clipPath id="a">
          <path
            fill="#fff"
            transform="translate(72.082 8.94)"
            d="M0 0h173.017v45H0z"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

type ColorOptions = 'navy' | 'teal' | 'coral' | 'black' | 'white';
interface ColorConfig {
  iconForegroundFill: string;
  iconBackgroundFill: string;
  iconStroke: string;
  wordmarkColor: string;
}

const styleMap: Record<ColorOptions, ColorConfig> = {
  navy: {
    iconForegroundFill: 'fill-navy-light',
    iconBackgroundFill: 'fill-navy-med',
    iconStroke: 'fill-grey-1',
    wordmarkColor: 'fill-grey-1',
  },
  coral: {
    iconForegroundFill: 'fill-coral-light',
    iconBackgroundFill: 'fill-coral-med',
    iconStroke: 'fill-grey-1',
    wordmarkColor: 'fill-grey-1',
  },
  teal: {
    iconForegroundFill: 'fill-teal-light',
    iconBackgroundFill: 'fill-teal-med',
    iconStroke: 'fill-grey-1',
    wordmarkColor: 'fill-grey-1',
  },
  black: {
    iconForegroundFill: 'fill-white-pure',
    iconBackgroundFill: 'fill-white-pure',
    iconStroke: 'fill-grey-1',
    wordmarkColor: 'fill-grey-1',
  },
  white: {
    iconForegroundFill: 'fill-transparent',
    iconBackgroundFill: 'fill-transparent',
    iconStroke: 'fill-white-pure',
    wordmarkColor: 'fill-white-pure',
  },
};
